import type { ReactNode } from "react";
import { MultiPurposeParagraph, Paragraph } from "@/components/Atoms/Paragraph";
import { MultiPurposeTitle } from "@/components/Atoms/Title";
import { FullBackgroundImage } from "@/components/Molecules/ImageCard";
import { OverlayShadow } from "@/components/Molecules/OverlayShadow/Overlay";
import styles from "./HeroRecipe.module.scss";

interface RecipeHeroShellProps {
  image: any;
  overlay?: boolean;
  children: ReactNode;
}

function RecipeHeroShell({ image, overlay, children }: RecipeHeroShellProps) {
  const defaultColor = {
    color: {
      hex: "#000",
    },
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.shell}>
        <div className={styles.background}>
          {overlay && (
            <OverlayShadow
              format="heroProduct"
              data="sdark"
              color={defaultColor.color}
              layout="right"
            />
          )}
          <FullBackgroundImage data={image} />
        </div>
        <div className={styles.grid}>
          <div className={styles.imageCol} aria-hidden />
          <div className={styles.copyCol}>{children}</div>
        </div>
      </div>
    </div>
  );
}

interface Props {
  config: any;
  title: string;
  description: string;
  image: any;
  overlay: any;
}

export default function HeroRecipe({
  config,
  title,
  description,
  image,
  overlay,
}: Props) {
  return (
    <RecipeHeroShell image={image} overlay={overlay}>
      <MultiPurposeTitle
        tag="h2"
        data={title}
        color={config?.heroTextColor?.color}
      />
      {description && (
        <Paragraph
          layout="left"
          copy={description}
          color={config?.heroTextColor?.color}
        />
      )}
    </RecipeHeroShell>
  );
}

interface PropsCocktail {
  config: any;
  title: string;
  description: string;
  image: any;
  label?: string;
}

export function HeroRecipeCocktail({
  config,
  title,
  description,
  image,
  label,
}: PropsCocktail) {
  return (
    <RecipeHeroShell image={image}>
      {label && (
        <MultiPurposeParagraph
          type="label"
          data={label}
          color={config?.heroTextColor?.color}
        />
      )}
      <MultiPurposeTitle
        tag="h2"
        data={title}
        color={config?.heroTextColor?.color}
      />
      {description && (
        <Paragraph
          layout="left"
          copy={description}
          color={config?.heroTextColor?.color}
        />
      )}
    </RecipeHeroShell>
  );
}
